import { kebabCase } from 'lodash';
export const buildCssInlineSsm = (css) => {
    return Object.keys(css)
        .map((key) => `.${key}{${toCssRules(css[key])}}`)
        .join('');
};
function toCssRules(ruleset) {
    const keys = Object.keys(ruleset);
    const validKeys = keys.filter(nonEmptyStringsAndNumbers, ruleset);
    return validKeys.map((key) => `${kebabCase(key)}:${ruleset[key]};`).join('');
}
function nonEmptyStringsAndNumbers(key) {
    if (typeof this[key] === 'string') {
        return !!this[key];
    }
    return typeof this[key] === 'number';
}
//# sourceMappingURL=build-css-inline-ssm.js.map